import jj from "./src/jj";
// 为组件提供 install 安装方法，供按需引入
jj.install = function (Vue) {
  Vue.component(jj.name, jj)

}

// 默认导出组件
export default jj



// WEBPACK FOOTER //
// ./src/components/jj/index.js